import { render, staticRenderFns } from "./ping_detail.vue?vue&type=template&id=147f39a5&scoped=true&"
import script from "./ping_detail.vue?vue&type=script&lang=ts&"
export * from "./ping_detail.vue?vue&type=script&lang=ts&"
import style0 from "./ping_detail.vue?vue&type=style&index=0&id=147f39a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147f39a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VIcon,VTab,VTabItem,VTabs})
